const container = {
  sm: { value: "40rem" },
  md: { value: "48rem" },
  lg: { value: "56rem" }, // Forsøker 56rem som standardbredde etter testing med Katrine
  xl: { value: "80rem" },
};

export const sizes = {
  container,
};
